import { AppenateCreateUserModel } from "../models/appenate-createuser.model";
export class EmployeeSetupModel {
  tblEmployeeId: number = -1;
  formId: string = "";
  employeeCode: string = "";
  firstName: string = "";
  lastName: string = "";
  mobile: string = "";
  telephone: string = "";
  email: string = "";
  profileImage: string = "../../../../assets/img/no-photo-available.png";
  webLogin: string = "No";
  clientId: number = 0;
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
  tblContractorId: number = 0;
  tblDepartmentId: number = 0;
  tblDepartmentId2: number = 0;
  userId: string = "";
  autoGenerateCode: boolean = true;
  appenateUser: string = "No";
  appenateUserId: string = "";
  tblDesignationId: number = 0;
}

export class EmployeeConfigurationModel {
  formId: string = "";
  formTitle: string = "Employee Details";
  addFormName: string = "Add Employee";
  editFormName: string = "Edit Employee";
  listReportFormName: string = "Saved Employee Details";
  gridHeight: number = 0;

  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  displayListCardView: boolean = false;
  displayContractorDropDownList: boolean = false;
  displayDepartmentDropDownList: boolean = false;
  autoGenerateEmployeeCode: boolean = true;

  requiredFields: RequiredFields = { employeeCode: false, firstName: true, lastName: true, mobile: true, telephone: true, email: false, profileImage: true, webLogin: true, appenateUser: false, designation:false };;
  allowedFields: AllowedFields = { employeeCode: false, firstName: true, lastName: true, mobile: true, telephone: true, email: true, profileImage: true, webLogin: true, appenateUser: false, designation: false };
  employeeRoles: any = [];
  fieldsTitle: FieldsTitle = new FieldsTitle();
  fieldsFormat: FieldsFormat = new FieldsFormat();
  selectEmployeeSection: boolean = false;
 
  redirectUrl:string = "";

  displayEmployeeByContractor:boolean = false;

  //AppenateFields
  appenateCreateUser: AppenateCreateUserModel = new AppenateCreateUserModel();
}

export class RequiredFields {
  employeeCode: boolean = false;
  firstName: boolean = true;
  lastName: boolean = true;
  mobile: boolean = true;
  telephone: boolean = true;
  email: boolean = true;
  profileImage: boolean = true;
  webLogin: boolean = true;
  appenateUser: boolean = false;
  designation: boolean = false;
}

export class AllowedFields {
  employeeCode: boolean = false;
  firstName: boolean = true;
  lastName: boolean = true;
  mobile: boolean = true;
  telephone: boolean = true;
  email: boolean = true;
  profileImage: boolean = true;
  webLogin: boolean = true;
  appenateUser: boolean = false;
  designation: boolean = false;
}

export class EmployeeContractorMappingModel {
  tblContractorId: number = 0;
  tblDepartmentId: number = 0;
  tblEmployeeId: number = 0;
  clientId: number = 0;
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
}

export class ValidationModel {

  isContractorDDLValid: boolean = true;
  contractorDDLValidationMessage: string = "Please select Contractor";

  isDepartmentValid: boolean = true;
  departmentValidationMessage: string = "Please select Department";

  isEmployeeCodeValid: boolean = true;
  employeeCodeValidationMessage: string = "Employee Code is required";

  isFirstNameValid: boolean = true;
  firstNameValidationMessage: string = "First Name is required";

  isLastNameValid: boolean = true;
  lastNameValidationMessage: string = "Last Name is required";

  isMobileValid: boolean = true;
  mobileValidationMessage: string = "Mobile is required";

  isTelephoneValid: boolean = true;
  telephoneValidationMessage: string = "Telephone is required";

  isProfileImageValid: boolean = true;
  profileImageValidationMessage: string = "Profile Image is required";

  isDesignationValid: boolean = true;
  designationValidationMessage: string = "Designation is required";
}

export class FieldsTitle {
  telephone1: string = "Telephone 1";
  telephone2: string = "Telephone 2";
}
export class FieldsFormat {
  telephone1: string = "";
  telephone2: string = "";
}
